import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import TextValidation from "src/shared/forms/validations/TextValidation";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IContactFirstNameInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.first_name" />,
  validationDisabled = false,
  ...rest
}: IContactFirstNameInputProps) => {
  const validations: ValidationHandler[] = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [
      Length(3, 32),
      TextValidation(<FormattedMessage id="form.validations.name.invalid" />),
    ];
  }, [validationDisabled]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
